// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--cc6a1";
export var rssContent = "rss-parser-module--rss-content--d616d";
export var rssImage = "rss-parser-module--rss-image--a4c55";
export var rssTitle = "rss-parser-module--rss-title--4ffce";